import gql from 'graphql-tag';

const VIEW_ALL_TAXONOMIES = gql`
  query Taxonomy {
    viewTaxonomy
  }
`;

export default VIEW_ALL_TAXONOMIES;
